import { render } from "./SurveyImprovements.vue?vue&type=template&id=737c826a"
import script from "./SurveyImprovements.vue?vue&type=script&lang=js"
export * from "./SurveyImprovements.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__